import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Flex, Form, Image, Row, Space, Typography } from 'antd';
import { MyInput, MySelect } from '../../../components';
import { apiCalls } from '../../../shared/Apis';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi } from '../../../shared';
const { Text, Title } = Typography

const ProfileSetting = () => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)
    const [ servicelookup, setServiceLookup ] = useState([])
    const dispatch = useDispatch()
    const { profiledata } = useSelector(state => state?.profilegetApi)
    useEffect(() => {
        dispatch(actionsApi?.getUpdateProfile())
    }, [dispatch])

    useEffect(() => {
        if (profiledata) {
            form.setFieldsValue({
                firstName: profiledata?.data?.firstName || '',
                lastName: profiledata?.data?.lastName || '',
                email: profiledata?.data?.email || '',
                age: profiledata?.data?.age || '',
                phoneNo: profiledata?.data?.phoneNo || '',
                city: profiledata?.data?.city || '',
                address: profiledata?.data?.address || '',
                street: profiledata?.data?.street || '',
                exp: profiledata?.projectDetails?.exp || '',
                details: profiledata?.projectDetails?.details || '',
                services: profiledata?.services?.map(data=>data?.id) || '',
            });
        }
    }, [profiledata, form]);

 
    const profilepost = async (formData) => {
        setLoading(true);
        const updatedFormData = {
            ...formData,
            services: formData?.services,
        };
        const result = await apiCalls.ProfileApi.profilepost(updatedFormData);
        setLoading(false);
    };

    const getService = async () => {
        try {
            const result = await apiCalls?.servicesLookup?.getService();
            if (result) setServiceLookup(result);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    useEffect(()=>{
        getService()
    },[])
    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={profilepost}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Flex justify='center' className='my-4'>
                        <Image src='/assets/images/logo.png' preview={false} width={150} className='radius-12' />
                    </Flex>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="firstName"
                        label="First Name"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="lastName"
                        label="Last Name"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="email"
                        label="Email Address"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="age"
                        label="Age"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="phoneNo"
                        type='number'
                        label="Phone Number"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="city"
                        label="City"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="address"
                        label="Address"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="street"
                        label="Street"
                        size='large'
                    />
                </Col>
                <Col span={24}>
                    <Divider />
                </Col>
                <Col span={24}>
                    <Title level={5}>Business details:</Title>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="exp"
                        label="Year of experience"
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MySelect
                        mode='multiple'
                        label='Skills/Services'
                        name='services'
                        size='large'
                        message='Please enter skills/services'
                        options={servicelookup}
                    />
                </Col>
                <Col span={24}>
                    <MyInput
                        textArea
                        name="details"
                        label="Details"
                        size='large'
                        rows={6}
                    />
                </Col>
                <Col span={24}>
                    <Space className="w-100 right">
                        <Button
                            className="btncancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            block
                            className='btnsave'
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            // onClick={() => form.submit()}
                        >
                            Update
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    );
};

export { ProfileSetting };
